import './header.component.scss'
import { throttle } from '../../application/utils/timings'
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock'
import { breakpoints } from '../../application/utils/breakpoints'
import { matchMedia } from '../../application/utils/machMedia'

const nav = document.querySelector('.header-nav');
const toggler = document.querySelector('.header-toggler');
const navigatorBack = document.createElement('DIV');
navigatorBack.classList.add('navigator-back');

const navUl = document.querySelector('.header-nav'),
  mq = window.matchMedia('(max-width: 1024px)');

navUl.addEventListener('click', (e) => {
  const megaSub = e.target.closest('.header-nav__item-link-sub'),
    secondMegaSub = e.target.closest('.header-nav__mega-overview-link--has-sub'),
    backButton = e.target.closest('.header-nav__mega-button');

  if(mq.matches){
    if (megaSub) {
      e.preventDefault();
      const fistSub = megaSub.nextElementSibling;
      fistSub.classList.add('header-nav__mega-submenu--active');
    }
    if (secondMegaSub) {
      e.preventDefault();
      const secSub = secondMegaSub.nextElementSibling;
      secSub.classList.add('header-nav__mega-wrap--active');
    }
    if (backButton) {
      backButton.parentNode.classList.remove('header-nav__mega-submenu--active','header-nav__mega-wrap--active')
    }
  }
})

function orientationChangeHandler(e) {
  if (!e.matches) {
    enableBodyScroll(nav)
    document.documentElement.classList.remove('is-filter-active')
    document.documentElement.classList.remove('is-navigation')
  }
}
const scrollCallback = throttle(() => {
  if (document.documentElement.classList.contains('is-scroll-force'))
    return false
  document.documentElement.classList.toggle('is-scroll', window.scrollY > 50)
}, 100)

window.addEventListener('scroll', scrollCallback)
scrollCallback()
if (toggler) {
  toggler.addEventListener('click', () => {
    if (document.documentElement.classList.contains('is-filter-active')) {
      document.documentElement.classList.remove('is-filter-active')
      clearAllBodyScrollLocks()
      return false
    }
    document.documentElement.classList.toggle('is-navigation')
    const isNavigation = document.documentElement.classList.contains(
      'is-navigation'
    )
    matchMedia('(orientation: portrait)')(orientationChangeHandler)
    if (isNavigation) {
      disableBodyScroll(nav)
      document.body.appendChild(navigatorBack)
      navigatorBack.addEventListener('click', () => {
        document.documentElement.classList.remove('is-navigation')
        document.body.removeChild(navigatorBack)
        enableBodyScroll(nav)
      })
    } else {
      enableBodyScroll(nav)
      document.body.removeChild(navigatorBack)
    }
  })
}
if (window.innerWidth <= breakpoints.medium) {
  document.querySelectorAll('.header-nav__item > a').forEach(root => {
    const container = root.closest('.header-nav__item')
    const dropdown = container.querySelector('.header-nav__submenu')
    const chevron = container.querySelector('.icon-chevron-down')
    if (dropdown) {
      root.addEventListener('click', event => {
        event.preventDefault()
        toggleDropdown(dropdown, container.classList.toggle('is-active'))
      })
      if (chevron) {
        chevron.addEventListener('click', () => {
          toggleDropdown(dropdown, container.classList.toggle('is-active'))
        })
      }
    }
  })
}

/**
 * function toggleDropdown(container, toggleResult) {
 *   if (toggleResult) {
 *     container.classList.add('active')
 *     container.style.height = 'auto'
 *     const height = container.clientHeight + 'px'
 *     container.style.height = '0px'
 *     setTimeout(() => {
 *       container.style.height = height
 *     }, 0)
 *   } else {
 *     container.style.height = '0px'
 *     container.addEventListener(
 *       'transitionend',
 *       () => {
 *         container.classList.remove('active')
 *       },
 *       { once: true }
 *     )
 *   }
 * }
 * if (window.innerWidth <= breakpoints.medium) {
 *   document.querySelectorAll('.header-nav__item > a').forEach(root => {
 *     const container = root.closest('.header-nav__item')
 *     const dropdown = container.querySelector('.header-nav__submenu')
 *     const chevron = container.querySelector('.icon-chevron-down')
 *     if (dropdown) {
 *       root.addEventListener('click', event => {
 *         event.preventDefault()
 *         toggleDropdown(dropdown, container.classList.toggle('is-active'))
 *       })
 *       if (chevron) {
 *         chevron.addEventListener('click', () => {
 *           toggleDropdown(dropdown, container.classList.toggle('is-active'))
 *         })
 *       }
 *     }
 *   })
 * }
 */